import { ComponentType, ReactElement } from 'react';
import { Badge } from '@op/opds.opux';
import styles from './TimeSpanCell.module.scss';
import Circle from './Circle';

interface TimeSpanCellProps {
  title?: string;
  icon: ComponentType<{ onDarkBg?: boolean }>;
  start?: boolean;
  end?: boolean;
  children?: string;
  isFirst?: boolean;
  isLast?: boolean;
}

const TimeSpanCell = ({
  title,
  icon: Icon,
  start,
  end,
  children,
  isFirst,
  isLast,
}: TimeSpanCellProps): ReactElement => {
  return (
    <>
      <div className={`${styles.cell} ${!title ? styles.noTitle : ''}`}>
        {title && (
          <dt className={styles.cellHeading}>
            <Badge badgeContent={title} />
          </dt>
        )}
        <dd>
          <Circle start={start} end={end} hideFirstLine={isFirst} hideLastLine={isLast}>
            <Icon onDarkBg={start || end} />
          </Circle>
        </dd>
        <dd className={`${styles.cellDescription} opds-styles-v1-text-label-small`}>
          {children}
        </dd>
      </div>
      <div className={`${styles.extraLine} ${isLast ? styles.hidden : ''}`} />
    </>
  );
};

export default TimeSpanCell;
